import React from 'react'

export default () => (
  <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
    <defs>
      <linearGradient
        x1="10.9271946%"
        y1="6.11754912%"
        x2="63.59508%"
        y2="88.6814251%"
        id="linearGradient-1"
      >
        <stop stopColor="currentColor" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="Artboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M22.8849193,24.9242353 C21.0278338,26.8917995 18.4603614,28.0340281 15.7555075,28.096 C13.050756,28.1762381 10.4267582,27.1686772 8.47080163,25.2988235 C6.50224122,23.4428345 5.35979264,20.8752068 5.29903692,18.1703529 C5.23950347,16.0393475 5.85555379,13.9441175 7.05903692,12.1844706 L5.53433104,8.81694117 C3.17009574,11.4051765 1.91080163,14.7425883 2.00491927,18.2550588 C2.08623757,21.8343671 3.5980682,25.2319183 6.20256634,27.6884705 C8.79231724,30.1603945 12.26347,31.4933416 15.8420958,31.3901176 C19.4201838,31.3045831 22.8158914,29.793422 25.2745663,27.1924705 L22.8839781,24.9242353 L22.8849193,24.9242353 Z"
        id="Shape"
        fill="url(#linearGradient-1)"
        fillRule="nonzero"
      />
      <path
        d="M9.64256634,10.0197647 L10.2336252,9.888 L11.2971546,7.66682353 C12.2524487,7.58023529 13.6500957,7.42682353 14.6458604,7.22164705 L14.3108016,12.8404706 L15.3300957,12.6183529 L17.5230369,6.59858824 C18.8406839,6.31341176 20.0755075,6.04329412 20.0755075,6.04329412 C21.2877429,5.77976471 22.2148017,5.10023529 22.0924487,4.53929412 C21.9729193,3.97835295 20.8529193,3.744 19.6322134,4.01035295 C19.6322134,4.01035295 18.3945663,4.27764705 17.0816251,4.56376471 L12.5865663,0 L11.566331,0.222117647 L14.2044487,5.19152941 C13.2115075,5.41741176 11.8797428,5.86164705 10.9715075,6.17505883 L9.08256634,4.60047059 L8.49150751,4.72752941 L9.87786044,7.19623529 L9.64256634,10.0197647 Z"
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)
